import "./App.css";

import { Navigate, Route, Routes } from "react-router-dom";

import AlertPopup from "./components/AlertPopup";
import { useAuthState } from "./provider/AuthProvider";

import * as Common from "./commons/common";

import DashboardLayout from "./layout/DashboardLayout";

import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import SelledCarManagement from "./pages/SellManagement/SelledCarManagement";
import OrderManagement from "./pages/SellManagement/OrderManagement";
import CustomerManagement from "./pages/SellManagement/CustomerManagement";
import ReferenceManagement from "./pages/SellManagement/ReferenceManagement";
import SelledCarMediaManagement from "./pages/SellManagement/SelledCarMediaManagement";
import RentCarManagement from "./pages/RentManagement/RentCarManagement";
import ReservationManagement from "./pages/RentManagement/ReservationManagement";
import InformationManagement from "./pages/RentManagement/InformationManagement";
import QuestionsManagement from "./pages/RentManagement/Questions";
import ManualManagement from "./pages/RentManagement/ManualManagement";
import RentCarMediaManagement from "./pages/RentManagement/RentCarMediaManagement";
import DigitalKey from "./pages/DigitalKey";
import Campingfair from "./pages/Event/Campingfair";
import Servey from "./pages/Event/Servey";
import Counseling from "./pages/CustomerServiceCenter/Counseling";
import TextNotice from "./pages/CustomerServiceCenter/TextNotice";
import TextRelease from "./pages/CustomerServiceCenter/TextRelease";
import Setup from "./pages/Setup";
import CampingCarShow from "./pages/Event/CampingCarShow";
import UserDetail from "./pages/UserDetail";
import AutoSalon from "./pages/Event/AutoSalon";
import NoticeManagement from "./pages/SellManagement/NoticeManagement";
import RentNoticeManagement from "./pages/RentManagement/RentNoticeManagement";
import RentStatistics from "./pages/RentManagement/RentStatistics";
import CarManagement from "./pages/CarManagement";
import CouponManagement from "./pages/CouponManagement";
import CampnicFair from "./pages/Event/CampnicFair";
import GreenCamp from "./pages/Event/GreenCamp";
import RentReviewManagement from "./pages/RentManagement/RentReviewManagement";
import RentB2bManagement from "./pages/RentManagement/RentB2bManagement";
import RentPeakSeasonManagement from "./pages/RentManagement/RentPeakSeasonManagement";
import Campingfair2024 from "./pages/Event/Campingfair2024";
import Campingfair2025 from "./pages/Event/Campingfair2025";

const PrivateRoute = (props: any) => {
    const userDetails = useAuthState();

    // console.log("userDetails", userDetails);

    // if (props.role !== undefined && props.role.length > 0) {
    //     const checkRole = userDetails?.user;
    //     return checkRole ? props.children : <NotFound />;
    // }
    if (props.role !== undefined && props.role.length > 0) {
        const checkRole = userDetails?.user && props.role.includes(userDetails?.user.authority);
        return checkRole ? props.children : <NotFound />;
    }

    return userDetails?.user ? props.children : <NotFound />;
};

function App() {
    return (
        <div>
            <AlertPopup />

            <Routes>
                <Route path="*" element={<NotFound />} />
                <Route path="/" element={<Navigate to={Common.PAGE_LOGIN} />} />
                <Route path={Common.PAGE_LOGIN} element={<Login />}></Route>
                <Route
                    path={Common.PAGE_DASHBOARD}
                    element={
                        <PrivateRoute>
                            <DashboardLayout>
                                <Dashboard />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_USERS}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN]}>
                            <DashboardLayout>
                                <Users />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_USERS + "/:id1"}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN]}>
                            <DashboardLayout>
                                <UserDetail />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_SELLED_CAR}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <SelledCarManagement />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_ORDERS}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <OrderManagement />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_CUSTOMER}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <CustomerManagement />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_REFERENCEROOM}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <ReferenceManagement />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_SEELED_CAR_MEDIAS}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <SelledCarMediaManagement />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_NOTICE}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <NoticeManagement />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_RENT_CAR}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_RENT_MANAGER]}>
                            <DashboardLayout>
                                <RentCarManagement />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_COUPON}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_RENT_MANAGER]}>
                            <DashboardLayout>
                                <CouponManagement />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_RENT_STATISTICS}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_RENT_MANAGER]}>
                            <DashboardLayout>
                                <RentStatistics />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_RESERVATION}
                    element={
                        <PrivateRoute
                            role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_RENT_MANAGER, Common.MEMBER_ROLE.ROLE_B2B_MANAGER]}
                        >
                            <DashboardLayout>
                                <ReservationManagement />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_INFORMATION}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_RENT_MANAGER]}>
                            <DashboardLayout>
                                <InformationManagement />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_QUESTIONS}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_RENT_MANAGER]}>
                            <DashboardLayout>
                                <QuestionsManagement />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_MANUALS}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_RENT_MANAGER]}>
                            <DashboardLayout>
                                <ManualManagement />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_RENT_CAR_MEDIAS}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_RENT_MANAGER]}>
                            <DashboardLayout>
                                <RentCarMediaManagement />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_RENT_REVIEW}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <RentReviewManagement />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_RENT_NOTICE}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <RentNoticeManagement />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_RENT_B2B}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <RentB2bManagement />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_RENT_PEAK_SEASON}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <RentPeakSeasonManagement />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_DIGITAL_KEY}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN]}>
                            <DashboardLayout>
                                <DigitalKey />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_CARS}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN]}>
                            <DashboardLayout>
                                <CarManagement />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_EVENT_CAMPINGFAIR}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <Campingfair />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_EVENT_CAMPINGCARSHOW}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <CampingCarShow />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_EVENT_AUTOSALON}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <AutoSalon />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_EVENT_CAMPNICFAIR}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <CampnicFair />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_EVENT_GREENCAMP}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <GreenCamp />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_EVENT_CAMPINGFAIR_2024}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <Campingfair2024 />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_EVENT_CAMPINGFAIR_2025}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <Campingfair2025 />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_SURVEYS}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <Servey />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_COUNSELING}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <Counseling />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_NOTICES}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <TextNotice />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_RELEASE}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN, Common.MEMBER_ROLE.ROLE_MANAGER]}>
                            <DashboardLayout>
                                <TextRelease />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Common.PAGE_LIST_SETUP}
                    element={
                        <PrivateRoute role={[Common.MEMBER_ROLE.ROLE_ADMIN]}>
                            <DashboardLayout>
                                <Setup />
                            </DashboardLayout>
                        </PrivateRoute>
                    }
                />
            </Routes>
        </div>
    );
}

export default App;
